import api from "@/api";

const state = {
    certificate: null,
};

const getters = {
    certificate(state) {
        return state.certificate;
    },
};

const actions = {
    async getCertificate({ commit }, { payload: { certificateId } }) {
        const res = await api.get(`/api/learning/certificate/${certificateId}`);
        commit("updateCertificate", {
            certificate: res.data?.certificateId ? res.data : null,
        });
    },
    async issueCertificate({ commit }, { payload: { progressId } }) {
        const res = await api.post("/api/learning/certificate", { progressId });
        commit("updateCertificate", { certificate: res.data });
    },
};

const mutations = {
    updateCertificate(state, { certificate }) {
        state.certificate = certificate;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
